// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Js_null_undefined from "rescript/lib/es6/js_null_undefined.js";
import * as ApolloClient__Utils from "../../../../ApolloClient__Utils.bs.js";
import * as ApolloClient__Cache_Core_Types_DataProxy from "./types/ApolloClient__Cache_Core_Types_DataProxy.bs.js";

var Js_ = {};

function preserveJsPropsAndContext(js, t) {
  return (function (js, t) {
            return Object.assign(js, t)
          })(js, t);
}

function fromJs(js) {
  var readFragment = function (Fragment, id, optimistic, canonizeResults, fragmentName, param) {
    var safeParse = function (param) {
      return ApolloClient__Utils.safeParse(Fragment.parse, param);
    };
    return Belt_Option.map(Caml_option.nullable_to_opt(js.readFragment({
                        id: id,
                        fragment: Fragment.query,
                        fragmentName: fragmentName,
                        optimistic: optimistic,
                        canonizeResults: canonizeResults
                      }, optimistic !== undefined ? Caml_option.valFromOption(optimistic) : undefined)), safeParse);
  };
  var readQuery = function (Operation, id, $staropt$star, optimistic, canonizeResults, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : (function (prim) {
          return prim;
        });
    var safeParse = function (param) {
      return ApolloClient__Utils.safeParse(Operation.parse, param);
    };
    return Belt_Option.map(Caml_option.nullable_to_opt(js.readQuery(ApolloClient__Cache_Core_Types_DataProxy.ReadQueryOptions.toJs({
                            query: Operation.query,
                            variables: variables,
                            id: id,
                            optimistic: optimistic,
                            canonizeResults: canonizeResults
                          }, mapJsVariables, Operation.serializeVariables), optimistic)), safeParse);
  };
  var writeFragment = function (Fragment, data, broadcast, overwrite, id, fragmentName, param) {
    return js.writeFragment(ApolloClient__Cache_Core_Types_DataProxy.WriteFragmentOptions.toJs({
                    data: data,
                    broadcast: broadcast,
                    overwrite: overwrite,
                    id: id,
                    fragment: Fragment.query,
                    fragmentName: fragmentName
                  }, Fragment.serialize));
  };
  var writeQuery = function (Operation, broadcast, overwrite, data, id, $staropt$star, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : (function (prim) {
          return prim;
        });
    return js.writeQuery(ApolloClient__Cache_Core_Types_DataProxy.WriteQueryOptions.toJs({
                    data: data,
                    broadcast: broadcast,
                    overwrite: overwrite,
                    query: Operation.query,
                    variables: variables,
                    id: id
                  }, mapJsVariables, Operation.serialize, Operation.serializeVariables));
  };
  var updateQuery = function (Operation, optimistic, canonizeResults, broadcast, overwrite, id, $staropt$star, update, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : (function (prim) {
          return prim;
        });
    var safeParse = function (param) {
      return ApolloClient__Utils.safeParse(Operation.parse, param);
    };
    return Belt_Option.map(Caml_option.nullable_to_opt(js.updateQuery(ApolloClient__Cache_Core_Types_DataProxy.UpdateQueryOptions.toJs({
                            id: id,
                            query: Operation.query,
                            variables: variables,
                            optimistic: optimistic,
                            canonizeResults: canonizeResults,
                            broadcast: broadcast,
                            overwrite: overwrite
                          }, mapJsVariables, Operation.serializeVariables), (function (jsData) {
                          return Js_null_undefined.fromOption(Belt_Option.map(Curry._1(update, Belt_Option.map(jsData === null ? undefined : Caml_option.some(jsData), Operation.parse)), Operation.serialize));
                        }))), safeParse);
  };
  var updateFragment = function (Fragment, fragmentName, optimistic, canonizeResults, broadcast, overwrite, id, update, param) {
    var safeParse = function (param) {
      return ApolloClient__Utils.safeParse(Fragment.parse, param);
    };
    return Belt_Option.map(Caml_option.nullable_to_opt(js.updateFragment(ApolloClient__Cache_Core_Types_DataProxy.UpdateFragmentOptions.toJs({
                            id: id,
                            fragment: Fragment.query,
                            fragmentName: fragmentName,
                            optimistic: optimistic,
                            canonizeResults: canonizeResults,
                            broadcast: broadcast,
                            overwrite: overwrite
                          }), (function (jsData) {
                          return Js_null_undefined.fromOption(Belt_Option.map(Curry._1(update, Belt_Option.map(jsData === null ? undefined : Caml_option.some(jsData), Fragment.parse)), Fragment.serialize));
                        }))), safeParse);
  };
  return preserveJsPropsAndContext(js, {
              rescript_readFragment: readFragment,
              rescript_readQuery: readQuery,
              rescript_writeFragment: writeFragment,
              rescript_writeQuery: writeQuery,
              rescript_updateFragment: updateFragment,
              rescript_updateQuery: updateQuery
            });
}

var ApolloCache = {
  Js_: Js_,
  preserveJsPropsAndContext: preserveJsPropsAndContext,
  fromJs: fromJs
};

var DataProxy;

var Types;

var Utils;

export {
  DataProxy ,
  Types ,
  Utils ,
  ApolloCache ,
}
/* ApolloClient__Utils Not a pure module */
